import type { HostContext, SearchResult, Searchable, SearchablesQuery, StartIndexType } from '../../@types';
import SearchService from '../SearchService';
import USSRequestBody from './USSRequestBody';
export default class UssSearch implements Searchable {
	searchParams: Record<string, any> = {};
	endpointPath = '';
	hostContext: HostContext;
	name: string;

	constructor(params: Record<string, any>) {
		this.searchParams = params.searchParams;
		this.endpointPath = params.endpointPath; // This will be of the form `/v1/users/me/search-assets`

		this.hostContext = params.hostContext;

		if (params?.searchParams?.source) {
			this.name = `USS+${params.searchParams.source}`;
		} else {
			this.name = 'USS';
		}
	}

	getSource(): string[] {
		const globalSources = Array.isArray(this.searchParams.scope)
			? this.searchParams.scope
			: [this.searchParams.scope];
		const filters = this.searchParams?.filters ?? [];
		const filterSources = filters.reduce(
			(scopes: string[], filter: Record<string, any>) =>
				scopes.concat(Array.isArray(filter.scope) ? filter.scope : [filter.scope]),
			[],
		);
		const source = new Set([...filterSources, ...globalSources]);
		return [...source];
	}

	private getUSSRequestBody(
		searchParams: SearchablesQuery,
		startIndex: StartIndexType,
		limit: number,
		flags?: Array<string>,
	) {
		const { query, filter, sort } = searchParams;
		const filters = USSRequestBody.getAssetRequestFilters(filter, this.hostContext);
		const ussRequestBody = Object.assign(this.searchParams, {
			filters,
			sort,
			pagination: {
				startIndex,
				limit,
			},
			query,
			flags,
		});
		return ussRequestBody;
	}

	search(
		query: SearchablesQuery,
		startIndex: StartIndexType,
		limit: number,
		flags?: Array<string>,
	): Promise<SearchResult> {
		const ussRequestBody = this.getUSSRequestBody(query, startIndex, limit, flags);

		return new Promise(async (resolve) => {
			const startTime = Date.now();
			const results = await new SearchService(this.hostContext)._performSearchDataRequest(
				ussRequestBody,
				this.endpointPath,
				'search-assets',
			);
			results.duration = Date.now() - startTime;
			resolve(results);
		});
	}
}
